import {
    addPvNew,
    getUrlParams,
    isBaiduMap,
    isHarmony,
    parseJson
} from '../../../../utils';
import pushTemplate1 from './components/pushTemplate1.vue';
import poiLine from '../poiLine.vue';
import {openUrlByOpenApi} from '@baidu/map-fe-utils';
import {mapGetters} from 'vuex';

export default {
    props: {
        // 观测器
        observer: {
            type: Object,
            default: () => {}
        },
        // push笔记数据
        pushData: {
            type: Object,
            default: () => {}
        },
        pushIndex: {
            type: Number,
            default: 0
        }
    },
    components: {
        'push-template1': pushTemplate1,
        poiLine
    },
    data() {
        // 反馈功能获取push测id
        const urlParams = getUrlParams(location.href);
        const {source = '', initialSource = '', ping_m = '', hang_n = '', pushfrom = '', topic = '', origin_from = ''} = urlParams || {};
        return {
            contentData: {},
            push_src_id: '',
            // 自定义标题
            pageTitle: '百度地图',
            // 作者头像等级icon
            vIconLogo:
                'https://map-mobile-resource.cdn.bcebos.com/icon/service/search/default/v-icon-logo.png',
            isForewarning: false,
            isQwzh: '',
            pushCategory: '',
            unique_id: '',
            tpSource: '',
            subSource: '',
            isBaiduMap: isBaiduMap(),
            isHarmony: isHarmony(),
            commentTextHeight: 0,
            source: source,
            // 主feed来源
            initialSource: initialSource,
            // 默认初始高度屏幕限制
            ping_m: ping_m,
            // 默认初始高度行数限制
            hang_n: hang_n,
            pushfrom: pushfrom,
            topic: topic,
            showMore: false,
            push_third_text: '',
            button_url: '', // 按钮跳转链接
            push_third_url: '',
            push_type: '',
            cover: {},
            origin_from: origin_from,
            levelOne: '',
            levelTwo: '',
            dataType: 1 // 0-评论，1-笔记
        };
    },
    computed: {
        ...mapGetters('dataList', [
            'requestTime'
        ]),
        ...mapGetters('url', [
            'uid',
            'abtest',
            'firstUnique_id'
        ]),
        heightStyle() {
            return {
                height: this.commentTextHeight > 0 ? this.commentTextHeight + 'px' : 'auto'
            };
        },
        // 默认的收起状态/展开/按屏收起/按行收起
        closeType() {
            const closeType =  Number(this.ping_m) > 0 ? 'ping'
                : Number(this.hang_n) > 0 ? 'hang'
                    : this.ping_m === 'no' || this.hang_n === 'no' ? 'open'
                        : 'default';

            return closeType;
        },
        // 默认的高度限制
        defaultHLimit() {
            // 屏幕高度
            const screenHeight = window.innerHeight;
            // 默认屏幕的1倍
            const DEFAULT_HEIGHT_MULTIPLIER = 1;
            // 行高
            const ROW_HEIGHT = 28;

            switch (this.closeType) {
                case 'ping':
                    return Number(this.ping_m) * screenHeight;
                case 'hang':
                    return Number(this.hang_n) * ROW_HEIGHT;
                default:
                    // 默认的高度限制，超出限制默认收起，默认初始高度是屏高的1.5倍
                    return screenHeight * DEFAULT_HEIGHT_MULTIPLIER;
            }
        },
        visiableForewarningIcon() {
            return this.isForewarning && !this.isBaiduMap && this.push_type !== 'warning';
        },
        warningPushClass() {
            const classObj = [];
            if (this.push_type === 'warning') {
                classObj.push('is-warning');
            }
            else if (this.isForewarning) {
                classObj.push('is-forewarning');
            }
            return classObj;
        }
    },
    created() {
        document.title = '百度地图';
        this.formatData();
    },
    async mounted() {
        if (this.closeType !== 'open') {
            this.heightHandle();
        }
        this.showHandle();
    },
    methods: {
        /**
         * 展开内容
         */
        handleOpen() {
            this.showMore = false;
            this.commentTextHeight = 0;
            addPvNew(['MCDfeed.NewMedia.detailspage.Microcoopen.click'], {
                unique_id: this.unique_id,
                tp: 'push',
                user_behavior_sessionid: this.requestTime,
                source: this.source,
                uid: this.uid || '',
                levelOne: this.levelOne,
                levelTwo: this.levelTwo,
                note_index: this.pushIndex,
                abtest: this.abtest || '',
                ...(this.pushData?.burying || {})
            });
            this.$emit('content-open');
        },
        // 内容的高度处理
        heightHandle() {
            this.$nextTick(async () => {
                if (this.$refs.pushTextContent && this.$refs.pushTextContent.clientHeight > this.defaultHLimit) {
                    // 收起
                    this.showMore = true;
                    // 默认收起高度
                    this.commentTextHeight = this.defaultHLimit;
                }
            });
        },
        formatData() {
            const {
                body: {
                    article: {headline = '', content = ''} = {},
                    push_third_text = '',
                    push_third_url = '',
                    push_type = '',
                    cover = {}
                } = {},
                actionBar: {author = {}} = {},
                unique_id = '',
                tpSource = '',
                levelOne = '',
                levelTwo = '',
                data_type = 1 // 0-评论，1-笔记
            } = this.pushData;
            const {subSource = '', isQmyj = 0, isQwzh = 0, pushCategory = '', pushScrId = ''} = author;
            this.contentData.headline = headline;
            this.contentData.content = content;
            this.author = author;
            this.unique_id = unique_id;
            this.tpSource = tpSource;
            this.isForewarning = Number(isQmyj) ? 1 : 0;
            this.isQwzh = Number(isQwzh) ? 1 : 0;
            this.pushCategory = pushCategory;
            this.subSource = subSource;
            this.push_src_id = pushScrId;
            this.push_third_text = push_third_text;
            this.push_third_url = push_third_url;
            const pushBtnObj = parseJson(this.push_third_ext);
            this.button_url = pushBtnObj.button_url || this.push_third_url || ''; // 按钮跳转链接
            this.push_type = push_type;
            this.cover = cover;
            this.levelOne = levelOne;
            this.levelTwo = levelTwo;
            this.dataType = Number(data_type);
        },
        showHandle() {
            // 监听对象
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    // 如果目标元素进入视窗
                    if (entry.intersectionRatio > 0) {
                        const showElement = entry.target;
                        this.buryHandle();
                        // 曝光上报完成，取消观察该元素
                        observer.unobserve(showElement);
                    }
                });
            });

            const obDom = this.$refs.pushContent;
            observer.observe(obDom);
        },
        buryHandle() {
            addPvNew(['PushLandingDefault.PGshow'], {
                unique_id: this.unique_id,
                warningnote: this.isForewarning ? '1' : '0', // 是否全民预警
                source: this.source,
                tp: 'push',
                authoritynote: this.isQwzh ? 1 : 0, // 是否权威账号
                pushcategory: this.pushCategory, // push栏目
                pushfrom: this.pushfrom,
                pushywf: this.push_type
            });
            addPvNew(['NewMedia.detailspage.PGshow'], {
                type: 'image',
                unique_id: this.unique_id,
                warningnote: this.isForewarning ? '1' : '0', // 是否全民预警
                source: this.source,
                initialSource: this.initialSource, // 主feed来源参数
                tp: 'push',
                note_style: 'Micro',
                authoritynote: this.isQwzh ? 1 : 0, // 是否权威账号
                pushcategory: this.pushCategory, // push栏目
                pushfrom: this.pushfrom,
                topic: this.topic,
                origin_from: this.origin_from,
                pushywf: this.push_type,
                user_behavior_sessionid: this.requestTime,
                uid: this.uid || '',
                levelOne: this.levelOne,
                levelTwo: this.levelTwo,
                is_comment: this.dataType === 1 ? 0 : 1,
                first_uniqueid: this.firstUnique_id,
                ...(this.pushData?.burying || {})
            });
        },
        /**
         * 点击跳转处理
         *
         * @param url - 待跳转的 URL
         */
        jumpUrl(url) {
            if (!this.isBaiduMap) {
                this.jumpToMap();
                return;
            }
            if (url === '') {
                return;
            }
            addPvNew(['MCEDse.PushLandingywf.click'], {
                unique_id: this.unique_id,
                warningnote: this.isForewarning ? '1' : '0', // 是否全民预警
                source: this.source,
                tp: 'push',
                authoritynote: this.isQwzh ? 1 : 0, // 是否权威账号
                pushcategory: this.pushCategory, // push栏目
                pushfrom: this.pushfrom,
                pushywf: this.push_type
            });
            openUrlByOpenApi(url);
        },
        jumpToMap() {
            this.$emit('open-Baidu-Map');
        }
    },
    watch: {
    },
    beforeDestroy() {
    }
};
